import { tabAccessControl } from "../../../_helpers/access-control";

let ReportTabs = [
    {
        text: "Bulk Stock",
        path: "/report-bulk-stock",
        applicationFeatureCode: "AlmondcoReportGridBulkStock"
    },
    {
        text: "Bulk Stock Hanwood",
        path: "/report-bulk-stock-hanwood",
        applicationFeatureCode: "AlmondcoReportGridBulkStockHanwood"
    },
    {
        text: "Bin Movement",
        path: `/intake-bin-movement`,
        applicationFeatureCode: "AlmondcoReportGridBinMovement",
    },
    // {
    //     text: "Bin Location",
    //     path: `/intake-bin-Location`,
    //     applicationFeatureCode: "AlmondcoReportGridBinLocation",
    // }
]

function GetIndexByTabName(tabName) {
    return tabAccessControl(ReportTabs).findIndex((x) => x.text == tabName);
}

export { ReportTabs, GetIndexByTabName };